const Alert = ({ type, children }) => {


    const classes = {
        'neutral': 'border-gray-200 bg-gray-100 text-gray-900',
        'info': 'border-blue-300 text-blue-900 bg-blue-50',
        'success': 'border-green-300 text-green-900 bg-green-50',
        'error': 'border-red-300 text-red-900 bg-red-50',
        'warning': 'border-yelllow-300 text-yellow-900 bg-yellow-50',
    }

    const className = classes[type];

    return <>

        <div className={`px-4 py-4 border rounded ${className} space-y-2`}>
            {children}
        </div>

    </>
}

export default Alert;